import React, { Component } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { applyDataTable } from "../../../../custom/dataTable";
import Edit from '../../../../../assets/img/svg/edit.svg';
import Delete from '../../../../../assets/img/svg/delete.svg';
import del from "../../../../../assets/img/svg/Del.svg"
import View from "../../../../../assets/img/svg/view.svg"
import * as agCharts from 'ag-charts-community';
import { AgChartsReact } from 'ag-charts-react';
import { red } from "@material-ui/core/colors";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../custom/Pagination";
import withRouter from "../../../../custom/withRouter";
import moment from "moment"
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../../assets/jss/customStyle"
import $ from "jquery"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../../_helpers/endpointService"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
} from 'chart.js';
import { Bar, Line, Scatter } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { ContinuousScale } from "ag-charts-community/dist/cjs/es5/scale/continuousScale";


let data
let data1
let labels = {}
let labels1 = {}
let options
let options1

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);

class ListViewHSEQPerform extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isbinded: false,
            isMobile: false,
            id: 0,
            ProjectId: 0,
            isAccess: false,
            addData: [],
            HSEQData: {}
        }
    }
    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate(`/hseq/performance/addnew`)
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate(`/hseq/performance/edit`)
    };

    DeleteItem = () => {
        const { dispatch } = this.props
        let apiUrl = API.HSEQ_URL + '/' + this.state.id
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.navigate("/hseq/performance")
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.getHSEQinfo(this.state.ProjectId)

                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };

    ViewPage = () => {
        this.props.navigate(`/hseq/performance/view`)
    };

    componentDidMount() {
        const { dispatch } = this.props;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isAccess: true }) : this.setState({ isAccess: false })
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"))
        applyDataTable("staffTable");
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        this.getHSEQData(this.state.ProjectId)
    }

    getHSEQData = (data) => {
        let apiUrl = API.HSEQ_URL + "/id?id=" + data
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "get",
            url: apiUrl
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                this.state.HSEQData = response.data
                this.setState({})
                this.bindData(this.state.HSEQData)
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }

    // getHSEQinfo = (data) => {
    //     let apiUrl = API.HSEQ_URL + '/projectId?projectId=' + data
    //     this.props.dispatch({ type: "SHOW_LOADER", data: true })
    //     axios({
    //         method: "get",
    //         url: apiUrl
    //     })
    //         .then((response) => {
    //             this.props.dispatch({ type: "SHOW_LOADER", data: false })
    //             if (response?.status === 200) {
    //                 this.state.addData = response.data

    //             }
    //             this.setState({}, () => {
    //                 this.bindData(this.state.addData);
    //                 if (this.state.addData.length > 0) {
    //                     this.getHSEQData(this.state.addData[0].HSEQPerformanceId)
    //                     this.state.id = this.state.addData[0].HSEQPerformanceId
    //                 } else {

    //                 }
    //             })
    //         })
    //         .catch((error) => {
    //             this.props.dispatch({ type: "SHOW_LOADER", data: false })
    //             if (error?.response?.status === 401) {
    //             }
    //         });
    // }

    bindData = (bindData) => {
        options = {
            indexAxis: 'x',
            elements: {
                bar: {
                    borderWidth: 2,
                    barPercentage: 0.4
                },
            },
            responsive: true,
            plugins: {
                legend: {
                    position: 'right',
                },
                datalabels: {
                    display: false,
                },
            },

        };

        options1 = {
            scales: {
                y: {
                  beginAtZero: true
                }
            },
            indexAxis: 'x',
            elements: {
                bar: {
                    borderWidth: 2,
                },
            },
            responsive: true,
            plugins: {
                legend: {
                    position: 'right',
                },
                datalabels: {
                    display: false,
                },
            },
        };

        var tempData = [];
        tempData.push(bindData?.Fatalities)
        tempData.push(bindData?.LTI)
        tempData.push(bindData?.RWC)
        tempData.push(bindData?.FAC)
        tempData.push(bindData?.MTC)
        tempData.push(bindData?.PropertyDamage)
        tempData.push(bindData?.EnvironmentalDamage)
        tempData.push(bindData?.MinorOilSpil)
        tempData.push(bindData?.ChemicalSpil)
        tempData.push(bindData?.GasLeakage)

        var monthList = [];
        var _LTIF = [];
        var _TRCF = [];
        var _TRIR = [];
        bindData.MonthList.map((i) => (
            monthList.push(i.Month),
            _LTIF.push(i.LTIF),
            _TRCF.push(i.TRCF),
            _TRIR.push(i.TRIR)
        ))

        data = {
            labels: ["Fatalities", "LTI", "RWC", "FAC", "MTC", ["Property", "Damage"], ["Environmental", "Damage"], ["Minor Oil", "Spill"], ["Chemical", "Spill"], ["Gas", "Leakage"]],
            datasets: [
                {
                    label: 'Incidents',
                    data: tempData,
                    borderColor: '#E10000',
                    backgroundColor: '#E10000',
                },
                // {
                //     label: 'TRCF',
                //     data: _TRCF,
                //     borderColor: '#000080',
                //     backgroundColor: '#000080',
                // },
            ],
        };

        data1 = {
            labels: monthList,
            datasets: [
                {
                    label: 'LTIF',
                    fill: false,
                    data: _LTIF,
                    borderColor: '#ADD8E6',
                    backgroundColor: '#ADD8E6',
                },
                {
                    label: 'TRCF',
                    fill: false,
                    data: _TRCF,
                    borderColor: '#F8ABAB',
                    backgroundColor: '#F8ABAB',
                },
                {
                    label: 'TRIR',
                    fill: false,
                    data: _TRIR,
                    borderColor: '#000080',
                    backgroundColor: '#000080',
                },
            ],
        };
        this.state.isbinded = true;
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#HSEQ1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Hseqper1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Hseqper").addClass("d-none");
        $("#Hseqper").removeClass("d-block");
        $("#HSEQPL").removeClass("active-color");
        $("#HSEQPT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#HSEQ1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Hseqper1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Hseqper").removeClass("d-none");
        $("#Hseqper").addClass("d-block");
        $("#HSEQPL").addClass("active-color");
        $("#HSEQPT").addClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    render() {
        let { classes, menuToggle } = this.props;
        const { addData, HSEQData } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6  mt-auto" >
                                    <List className="pt-3 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"HSEQ" + "1"} className=' textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="HSEQ" className="naviIcon ml-auto" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>HSEQ Performance</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto border-top" : "ml-auto"} style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {/* {this.state.isAccess?<>
                    {this.state.isMobile ? 
                    
                    <table className="dataTable" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} disabled={(this.state.isAccess == true && this.state.HSEQData.length != []) ? false : true} onClick={() => this.EditPage()}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} disabled={(this.state.isAccess == true && this.state.HSEQData.length != []) ? false : true} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={classes.button}  onClick={() => this.AddNew()}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <>
                            <div className="row pl-2 border-bottom">
                                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                    <button className={`${classes.button}`} disabled={(this.state.isAccess == true && this.state.HSEQData.length != []) ? false : true} onClick={() => this.EditPage()} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                    <button className={`${classes.button}`} disabled={(this.state.isAccess == true && this.state.HSEQData.length != []) ? false : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                    <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                        <button className={classes.button} onClick={() => this.AddNew()} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</button>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    </>:<></>} */}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>HSEQ Performance</h6>}
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive" style={window.innerWidth < 1000 ? { width: "101%", overflowX: "scroll" } : { width: "101%" }}>
                                <table id="" className="table table-hover product_table">
                                    <thead>
                                        <tr className="table-active">
                                            <th width="11%" className="border-right border-left align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>From Date</span></th>
                                            <th width="11%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>To Date</span></th>
                                            <th width="9%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Fatalities</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>LTI</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>RWC</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>FAC</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>MTC</span></th>
                                            <th width="9%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Property Damage</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Environmental Damage</span></th>
                                            <th width="9%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Minor Oil Spill</span></th>
                                            <th width="9%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Chemical Spill</span></th>
                                            <th width="8%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>Gas Leakage</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>LTIF</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>TRCF</span></th>
                                            <th width="6%" className="border-right align-middle"><span className="spandoc-thead" style={{ color: "#000000" }}>TRIR</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>{HSEQData !== "" ? <>
                                            <td className="spandoc-td align-middle border-right border-left">{moment(HSEQData.FromDate).format('DD/MM/YYYY')}</td>
                                            <td className="spandoc-td align-middle border-right">{moment(HSEQData.ToDate).format('DD/MM/YYYY')}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.Fatalities}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.LTI}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.RWC}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.FAC}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.MTC}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.PropertyDamage}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.EnvironmentalDamage}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.MinorOilSpil}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.ChemicalSpil}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.GasLeakage}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.LTIF}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.TRCF}</td>
                                            <td className="spandoc-td align-middle border-right text-right">{HSEQData.TRIR}</td>
                                        </>
                                            : <>
                                                <td className="border-right border-left"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                                <td className="border-right"></td>
                                            </>}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div style={window.innerWidth < 900 ? { width: "101%", overflowX: "scroll" } : { width: "101%" }} className=" table-responsive">

                                <table className="table mt-2 text-center text-center">
                                    <thead>
                                        <tr>
                                            <th className="border-top border-right border-left" width="150px" style={{ minWidth: window.innerWidth < 1000 ? '350px' : "" }}><span className="spandoc-thead">Performance - Yearly</span></th>
                                            {HSEQData.MonthList && HSEQData.MonthList.map((i, ind) => (
                                                <th className="border-top border-right border-left Nowrap" width="70px" style={{ minWidth: window.innerWidth < 1000 ? '150px' : "" }}><span className="spandoc-thead">{i.Month}</span></th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th className="border-right border-left spanTopBar">LTIF</th>
                                            {HSEQData.MonthList && HSEQData.MonthList.map((i, ind) => (
                                                <td className="border-right border-left spandoc-td text-right">{i.LTIF}</td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="border-right border-left spanTopBar">TRCF</th>
                                            {HSEQData.MonthList && HSEQData.MonthList.map((i, ind) => (
                                                <td className="border-right border-left spandoc-td text-right">{i.TRCF}</td>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th className="border-right border-left spanTopBar">TRIR</th>
                                            {HSEQData.MonthList && HSEQData.MonthList.map((i, ind) => (
                                                <td className="border-right border-left spandoc-td text-right">{i.TRIR}</td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5">
                                <h6>HSEQ Performance - Indicator</h6>
                                <div class="chartWrapper" style={window.innerWidth < 1000 ? { overflowX: "scroll" } : { overflowX: "hidden" }}>
                                    {this.state.isbinded ?
                                        <div class="chartAreaWrapper" style={window.innerWidth < 1000 ? {} : { width: "100%" }}>
                                            <Bar options={options} className="col-sm-12 col-12 col-lg-12 col-xl-12 col-md-12" data={data} height={50} />
                                        </div>
                                        :
                                        ""
                                    }
                                </div>
                            </div>
                            <div className={this.state.isMobile ? "fw-600 mt-2 mb-2 px-3" : "fw-600 mt-2 mb-2 px-1"}>
                                Note:<br></br>
                                LTI - Lost Time Injury<br></br>
                                RWC - Restricted Work Case<br></br>
                                FAC - First Aid Case<br></br>
                                MTC - Medical Treatment Case
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5">
                                <h6>LTIF,TRCF and TRIR Rate</h6>
                                <div class="chartWrapper" style={window.innerWidth < 1000 ? { overflowX: "scroll" } : { overflowX: "hidden" }}>
                                    {this.state.isbinded ?
                                        <div class="chartAreaWrapper" style={window.innerWidth < 1000 ? {} : { width: "100%" }}>
                                            <Line options={options1} className="col-sm-12 col-12 col-lg-12 col-xl-12 col-md-12" data={data1} height={50} />
                                        </div>
                                        :
                                        ""
                                    }
                                </div>
                            </div>
                            <div className={this.state.isMobile ? "fw-600 mt-2 mb-2 px-3" : "fw-600 mt-2 mb-2 px-1"}>
                                Note :<br></br>
                                LTIF - Lost Time Injury Frequency<br></br>
                                TRCF - Total Recordable Case Frequency<br></br>
                                TRIR - Total Recordable Incident Rate
                            </div>
                        </div>
                    </div>
                    <div class="modal fade pt-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        // projectStatus: state.projectReducer.projectStatus || [],
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

ListViewHSEQPerform.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewHSEQPerform))
);
